/* Recently Viewed Products — external asset.
 * Loaded conditionally only when the recently-viewed section renders.
 */
(function () {
  if (customElements.get('custom-recently-viewed')) return;

  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
      this.storageKey = 'recently-viewed-product-handles';
    }

    connectedCallback() {
      const currentHandle = this.dataset.productHandle;
      if (currentHandle) {
        this.addProductHandle(currentHandle);
      }
      this.renderProducts();
      this.installGlobalQuickAddGuard();
    }

    installGlobalQuickAddGuard() {
      if (window.__recentlyViewedQuickAddGuardInstalled) return;
      window.__recentlyViewedQuickAddGuardInstalled = true;

      document.addEventListener(
        'click',
        function (event) {
          if (event.target.closest('.recently-viewed-products .quick-add')) {
            event.stopPropagation();
          }
        },
        true
      );
    }

    getStoredHandles() {
      try {
        const raw = localStorage.getItem(this.storageKey);
        return raw ? JSON.parse(raw) : [];
      } catch (error) {
        return [];
      }
    }

    addProductHandle(handle) {
      let handles = this.getStoredHandles();
      handles = handles.filter((existingHandle) => existingHandle !== handle);
      handles.unshift(handle);

      const storageLimit = 10;
      if (handles.length > storageLimit) {
        handles = handles.slice(0, storageLimit);
      }

      localStorage.setItem(this.storageKey, JSON.stringify(handles));
    }

    renderProducts() {
      let handles = this.getStoredHandles();

      const currentHandle = this.dataset.productHandle;
      if (currentHandle) {
        handles = handles.filter((handle) => handle !== currentHandle);
      }

      const maxProducts = parseInt(this.dataset.maxProducts, 10) || 8;
      handles = handles.slice(0, maxProducts);

      if (!handles.length) {
        this.remove();
        return;
      }

      // Use sessionStorage cache so repeated views on the same page don't re-fetch.
      const cacheKey = 'rvp-cache:' + handles.join(',');
      let cached = null;
      try {
        cached = sessionStorage.getItem(cacheKey);
      } catch (e) { /* ignore */ }

      const query = handles.join(',');
      const url = `${this.dataset.url}${encodeURIComponent(query)}`;

      const doFetch = () =>
        fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.text();
          })
          .then((text) => {
            try {
              sessionStorage.setItem(cacheKey, text);
            } catch (e) { /* ignore */ }
            const html = new DOMParser().parseFromString(text, 'text/html');
            const fetchedSection = html.querySelector('custom-recently-viewed');

            if (fetchedSection && fetchedSection.innerHTML.trim().length) {
              this.innerHTML = fetchedSection.innerHTML;
              this.relocateQuickAddButtons();
            } else {
              this.remove();
            }
          })
          .catch((error) => {
            console.error('Recently viewed products failed to load:', error);
            this.remove();
          });

      if (cached) {
        const html = new DOMParser().parseFromString(cached, 'text/html');
        const fetchedSection = html.querySelector('custom-recently-viewed');
        if (fetchedSection && fetchedSection.innerHTML.trim().length) {
          this.innerHTML = fetchedSection.innerHTML;
          this.relocateQuickAddButtons();
          // Refresh in background for freshest data.
          doFetch();
          return;
        }
      }

      doFetch();
    }

    relocateQuickAddButtons() {
      this.querySelectorAll('.card-wrapper').forEach((card) => {
        const quickAdd = card.querySelector('.quick-add');
        const media = card.querySelector('.card__media');
        if (quickAdd && media && quickAdd.parentElement !== media) {
          media.insertAdjacentElement('beforeend', quickAdd);
        }

        if (quickAdd && !quickAdd.dataset.clickGuardAdded) {
          quickAdd.addEventListener('click', function (event) {
            event.stopPropagation();
          });

          card.querySelectorAll('a').forEach((link) => {
            if (!link.dataset.quickAddGuardAdded) {
              link.addEventListener('click', function (event) {
                if (event.target.closest('.quick-add')) {
                  event.preventDefault();
                  event.stopPropagation();
                }
              });
              link.dataset.quickAddGuardAdded = 'true';
            }
          });

          quickAdd.dataset.clickGuardAdded = 'true';
        }

        const form = quickAdd ? quickAdd.querySelector('form[action*="/cart/add"]') : null;
        if (form && !form.dataset.ajaxGuardAdded) {
          form.addEventListener(
            'submit',
            function (event) {
              event.preventDefault();
              event.stopPropagation();

              const submitBtn = form.querySelector('[type="submit"]');
              if (submitBtn) submitBtn.disabled = true;

              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({
                  items: [
                    {
                      id: form.querySelector('[name="id"]').value,
                      quantity: 1,
                    },
                  ],
                }),
              })
                .then((res) => res.json())
                .then((addResult) => {
                  if (addResult && addResult.status) {
                    console.error('Add to cart error:', addResult.description || addResult.message);
                    return;
                  }

                  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

                  fetch('/?sections=cart-drawer,cart-icon-bubble')
                    .then((res) => res.json())
                    .then((sections) => {
                      const cartDrawer = document.querySelector('cart-drawer');

                      if (cartDrawer && sections['cart-drawer']) {
                        const parsed = new DOMParser().parseFromString(
                          sections['cart-drawer'],
                          'text/html'
                        );
                        const newDrawer = parsed.querySelector('cart-drawer');
                        if (newDrawer) cartDrawer.innerHTML = newDrawer.innerHTML;
                        cartDrawer.classList.remove('is-empty');
                      }

                      const bubble = document.getElementById('cart-icon-bubble');
                      if (bubble && sections['cart-icon-bubble']) {
                        const parsed = new DOMParser().parseFromString(
                          sections['cart-icon-bubble'],
                          'text/html'
                        );
                        const newBubble = parsed.getElementById('cart-icon-bubble');
                        if (newBubble) bubble.innerHTML = newBubble.innerHTML;
                      }

                      if (cartDrawer && typeof cartDrawer.open === 'function') {
                        cartDrawer.open();
                      } else if (cartDrawer && typeof cartDrawer.show === 'function') {
                        cartDrawer.show();
                      } else if (cartDrawer) {
                        cartDrawer.classList.add('active', 'is-open', 'open');
                        cartDrawer.setAttribute('open', '');
                        cartDrawer.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
                      }

                      const cartIconTrigger = document.querySelector(
                        '#cart-icon-bubble, a[href="/cart"], .header__icon--cart'
                      );
                      if (
                        cartIconTrigger &&
                        !(cartDrawer && (typeof cartDrawer.open === 'function' || typeof cartDrawer.show === 'function'))
                      ) {
                        cartIconTrigger.dispatchEvent(
                          new MouseEvent('click', { bubbles: true, cancelable: true })
                        );
                      }
                    })
                    .catch((error) => {
                      console.error('Cart drawer refresh failed:', error);
                    });
                })
                .catch((error) => {
                  console.error('Add to cart failed:', error);
                })
                .finally(() => {
                  if (submitBtn) submitBtn.disabled = false;
                });
            },
            true
          );
          form.dataset.ajaxGuardAdded = 'true';
        }
      });
    }
  }

  customElements.define('custom-recently-viewed', RecentlyViewedProducts);
})();